// extracted by mini-css-extract-plugin
module.exports = {"matrix-table--pad3":"m_0 ml-3","matrix-table--pad4":"m_1 ml-5","matrix-table__title":"m_2","matrix-table__true":"m_3","matrix-table__false":"m_4"};